export const WBS_FETCH_WBS_BEGIN = 'WBS_FETCH_WBS_BEGIN';
export const WBS_FETCH_WBS_SUCCESS = 'WBS_FETCH_WBS_SUCCESS';
export const WBS_FETCH_WBS_FAILURE = 'WBS_FETCH_WBS_FAILURE';
export const WBS_FETCH_WBS_DISMISS_ERROR = 'WBS_FETCH_WBS_DISMISS_ERROR';
export const WBS_SAVE_COMPONENT_BEGIN = 'WBS_SAVE_COMPONENT_BEGIN';
export const WBS_SAVE_COMPONENT_SUCCESS = 'WBS_SAVE_COMPONENT_SUCCESS';
export const WBS_SAVE_COMPONENT_FAILURE = 'WBS_SAVE_COMPONENT_FAILURE';
export const WBS_SAVE_COMPONENT_DISMISS_ERROR = 'WBS_SAVE_COMPONENT_DISMISS_ERROR';
export const WBS_SAVE_DELIVERABLE_BEGIN = 'WBS_SAVE_DELIVERABLE_BEGIN';
export const WBS_SAVE_DELIVERABLE_SUCCESS = 'WBS_SAVE_DELIVERABLE_SUCCESS';
export const WBS_SAVE_DELIVERABLE_FAILURE = 'WBS_SAVE_DELIVERABLE_FAILURE';
export const WBS_SAVE_DELIVERABLE_DISMISS_ERROR = 'WBS_SAVE_DELIVERABLE_DISMISS_ERROR';
export const WBS_SAVE_WORKPACKAGE_BEGIN = 'WBS_SAVE_WORKPACKAGE_BEGIN';
export const WBS_SAVE_WORKPACKAGE_SUCCESS = 'WBS_SAVE_WORKPACKAGE_SUCCESS';
export const WBS_SAVE_WORKPACKAGE_FAILURE = 'WBS_SAVE_WORKPACKAGE_FAILURE';
export const WBS_SAVE_WORKPACKAGE_DISMISS_ERROR = 'WBS_SAVE_WORKPACKAGE_DISMISS_ERROR';
export const WBS_CLOSE_SNACK_BAR = 'WBS_CLOSE_SNACK_BAR';
export const WBS_DELETE_COMPONENT_BEGIN = 'WBS_DELETE_COMPONENT_BEGIN';
export const WBS_DELETE_COMPONENT_SUCCESS = 'WBS_DELETE_COMPONENT_SUCCESS';
export const WBS_DELETE_COMPONENT_FAILURE = 'WBS_DELETE_COMPONENT_FAILURE';
export const WBS_DELETE_COMPONENT_DISMISS_ERROR = 'WBS_DELETE_COMPONENT_DISMISS_ERROR';
export const WBS_DELETE_DELIVERABLE_BEGIN = 'WBS_DELETE_DELIVERABLE_BEGIN';
export const WBS_DELETE_DELIVERABLE_SUCCESS = 'WBS_DELETE_DELIVERABLE_SUCCESS';
export const WBS_DELETE_DELIVERABLE_FAILURE = 'WBS_DELETE_DELIVERABLE_FAILURE';
export const WBS_DELETE_DELIVERABLE_DISMISS_ERROR = 'WBS_DELETE_DELIVERABLE_DISMISS_ERROR';
export const WBS_DELETE_WORKPACKAGE_BEGIN = 'WBS_DELETE_WORKPACKAGE_BEGIN';
export const WBS_DELETE_WORKPACKAGE_SUCCESS = 'WBS_DELETE_WORKPACKAGE_SUCCESS';
export const WBS_DELETE_WORKPACKAGE_FAILURE = 'WBS_DELETE_WORKPACKAGE_FAILURE';
export const WBS_DELETE_WORKPACKAGE_DISMISS_ERROR = 'WBS_DELETE_WORKPACKAGE_DISMISS_ERROR';
export const WBS_FETCH_DELIVERABLE_CATALOG_BEGIN = 'WBS_FETCH_DELIVERABLE_CATALOG_BEGIN';
export const WBS_FETCH_DELIVERABLE_CATALOG_SUCCESS = 'WBS_FETCH_DELIVERABLE_CATALOG_SUCCESS';
export const WBS_FETCH_DELIVERABLE_CATALOG_FAILURE = 'WBS_FETCH_DELIVERABLE_CATALOG_FAILURE';
export const WBS_FETCH_DELIVERABLE_CATALOG_DISMISS_ERROR = 'WBS_FETCH_DELIVERABLE_CATALOG_DISMISS_ERROR';
export const WBS_FETCH_PROJECT_STATUS_BEGIN = 'WBS_FETCH_PROJECT_STATUS_BEGIN';
export const WBS_FETCH_PROJECT_STATUS_SUCCESS = 'WBS_FETCH_PROJECT_STATUS_SUCCESS';
export const WBS_FETCH_PROJECT_STATUS_FAILURE = 'WBS_FETCH_PROJECT_STATUS_FAILURE';
export const WBS_FETCH_PROJECT_STATUS_DISMISS_ERROR = 'WBS_FETCH_PROJECT_STATUS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/wbs/redux/constants.js